export const policyOriginTypes = Object.freeze([
  { key: 0, value: 'Manual' },
  { key: 1, value: 'Downloads' },
  { key: 2, value: 'Data Import' },
  { key: 3, value: 'NowCerts Web Services' },
  { key: 4, value: 'Data Import (Manual)' },
  { key: 5, value: 'EDocs' },
  { key: 6, value: 'Tasks' },
  { key: 7, value: 'SMS' },
  { key: 8, value: 'Automate' },
  { key: 10, value: 'Momentum' },
  { key: 20, value: 'NowCerts Carrier Downloads Service' },
  { key: 21, value: 'Notes Outlook Plugin' },
  { key: 30, value: 'Manual-Push' },
]);